/**
 * Admin Routes
 * CD-269: Setup Vue Router
 * Routes for the admin backoffice (admin.clonedetector.com)
 */
export default [
  // Authenticated admin routes with AdminLayout
  {
    path: '/',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: '',
        name: 'admin-dashboard',
        component: () => import('@/views/admin/DashboardView.vue'),
        meta: { title: 'Admin Dashboard' }
      },
      {
        path: 'users',
        name: 'admin-users',
        component: () => import('@/views/admin/UsersView.vue'),
        meta: { title: 'User Management' }
      },
      {
        // :id constrained to integers — cdums.users.id is INT.
        path: 'users/:id(\\d+)',
        name: 'admin-user-detail',
        component: () => import('@/views/admin/UserDetailView.vue'),
        meta: { title: 'User Details' }
      },
      {
        path: 'scans',
        name: 'admin-scans',
        component: () => import('@/views/admin/ScansView.vue'),
        meta: { title: 'Scan Management' }
      },
      {
        // Same shape as user routes: integer CDUMS queue id OR 16-char
        // hex CDBE scan_id.
        path: 'scans/:id(\\d+|[0-9a-f]{16})',
        name: 'admin-scan-detail',
        component: () => import('@/views/admin/ScanDetailView.vue'),
        meta: { title: 'Scan Details' }
      },
      {
        path: 'queue',
        name: 'admin-queue',
        component: () => import('@/views/admin/QueueManagementView.vue'),
        meta: { title: 'Scan Queue Management' }
      },
      {
        path: 'reports',
        name: 'admin-reports',
        component: () => import('@/views/admin/ReportsView.vue'),
        meta: { title: 'Financial Reports' }
      },
      {
        path: 'email-templates',
        name: 'admin-email-templates',
        component: () => import('@/views/admin/EmailTemplatesView.vue'),
        meta: { title: 'Email Templates' }
      },
      {
        path: 'audit-logs',
        name: 'admin-audit-logs',
        component: () => import('@/views/admin/AuditLogsView.vue'),
        meta: { title: 'Audit Logs' }
      },
      {
        path: 'failure-journal',
        name: 'admin-failure-journal',
        component: () => import('@/views/admin/FailureJournalView.vue'),
        meta: { title: 'Failure Journal' }
      },
      {
        path: 'admins',
        name: 'admin-admins',
        component: () => import('@/views/admin/AdminsView.vue'),
        meta: { title: 'Admin Management' }
      },
      {
        path: 'settings',
        name: 'admin-settings',
        component: () => import('@/views/admin/SettingsView.vue'),
        meta: { title: 'Admin Settings' }
      }
    ]
  },
  // Admin Auth routes
  {
    path: '/auth',
    component: () => import('@/layouts/AuthLayout.vue'),
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/auth/LoginView.vue'),
        meta: { guestOnly: true, title: 'Admin Sign In' }
      }
    ]
  },
  // Error pages
  {
    path: '/forbidden',
    name: 'forbidden',
    component: () => import('@/views/ForbiddenView.vue'),
    meta: { title: 'Access Denied' }
  },
  // 404 catch-all
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { title: 'Page Not Found' }
  }
]
